import { DaylightCommonContent } from "../../../../modules/content/components/DaylightCommonContent/DaylightCommonContent";
import { DaylightSection } from "../../../../modules/content/components/DaylightSection/DaylightSection";
import type { ISimpleHeroBlockProps } from "./SimpleHeroBlock.props";

export const SimpleHeroBlock = ({
  alignment,
  anchorId,
  buttons,
  description,
  eyebrow,
  heading,
  parentClass,
  spacing,
}: ISimpleHeroBlockProps) => {
  if (!eyebrow && !heading && !description && !buttons?.length) return null;

  return (
    <DaylightSection className={parentClass} id={anchorId} spacing={spacing}>
      <div className="flex min-h-[26rem] items-end border-primary border-t pt-12 md:min-h-[32rem]">
        <DaylightCommonContent
          alignment={alignment}
          buttons={buttons}
          className="w-full"
          description={description}
          eyebrow={eyebrow}
          heading={heading}
          headingAs="h1"
          headingClassName="max-w-[14ch] text-[clamp(3.25rem,9.6vw,12rem)] leading-[0.85] tracking-[-0.04em]"
        />
      </div>
    </DaylightSection>
  );
};

SimpleHeroBlock.displayName = "Block::SimpleHeroBlock";
